import { useNavigate, Link } from 'react-router-dom';
import { useCreateCompany } from '../../../hooks/company/useCreateCompany.js';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import ValidationErrors from '../../../components/alerts/ValidationErrors.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function CreateCompany() {
    const navigate = useNavigate();
    const {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        resetForm,
        clearError,
        clearValidationErrors
    } = useCreateCompany();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await submit();
    };

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Registrar empresa</h1>
                <div className="row mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-7 mt-5 m-auto">
                        <div className="card mb-3">
                            <div className="pt-4 px-4 pt-md-5 px-md-5">
                                {/* Muestra el error del validator del backend */}
                                <ValidationErrors errors={validationErrors} onClose={clearValidationErrors} />
                                <form onSubmit={handleSubmit}>
                                    <div className="form-floating mb-3">                                                                                
                                        <input className="form-control" id="floatingName" placeholder="Nombre" name="name" type="text" maxLength="100" value={form.name} onChange={handleChange} required />
                                        <label htmlFor="floatingName">Nombre *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                        
                                        <input className="form-control" id="floatingShortname" placeholder="Nombre corto del área" type="text" name="shortname" maxLength="30" value={form.shortname} onChange={handleChange} required />
                                        <label htmlFor="floatingShortname">Nombre corto de la empresa *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                                       
                                        <textarea className="form-control" id="floatingDescription" placeholder="Comentarios" name="description" maxLength="255" value={form.description} onChange={handleChange} style={{height:"100px"}} ></textarea>
                                        <label htmlFor="floatingDescription">Comentarios</label>                                        
                                    </div>
                                    <div className="mt-5 mb-4 text-end">
                                        <button  type="submit" className="btn btn-primary">Guardar</button>
                                        <Link to={ROUTES.LINKROOTCOMPANY}  type="button" className="ms-3 btn btn-secondary">Cancelar</Link>                                        
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessModal
                show={!!success}
                message={success}
                onClose={() => {
                    resetForm();
                    navigate(ROUTES.CREATE_COMPANY);
                }}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={clearError}
            />
        </>
    );
}